'use strict';

(function (angular, undefined) {
	'use strict';

	App.factory('AMSApi', ['restmod', 'inflector', function (restmod, inflector) {

		return restmod.mixin('DefaultPacker', { // include default packer extension
			$config: {
				style: 'AMS',
				primaryKey: 'id',
				jsonMeta: 'meta',
				jsonLinks: 'links'
			}
		});
	}]);
})(angular);
